import type { ModelData } from '@/shared/stores/model-utils'

export const model12InitialModel: ModelData = {
    name: 'Template 12 - Double Door With Solid Frames',
    modelId: 'model12',
    type: 'DOOR',
    description:
      '11-variant double door with solid frames and dual door opening',
    width: 1400,
    height: 2200,
    photoId: null,
    attachments: [],
    parameters: [
      // Main Frame profiles
      {
        positionId: 'top_frame_profile',
        type: 'PROFILE',
        width: 1400,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 0, y: 0, z: 0 },
      },
      {
        positionId: 'left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2200,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 0, y: 0, z: 0 },
      },
      {
        positionId: 'right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2200,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 1400, y: 0, z: 0 },
      },

      {
        positionId: 'middle_frame_profile',
        type: 'PROFILE',
        width: 1280,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 60, y: 240, z: 0 },
      },

      // Door Frames
      {
        positionId: 'middle_vertical_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1900,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 470, y: 300, z: 0 },
      },
      // door 1
      {
        positionId: 'door_1_left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1900,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 60, y: 300, z: 0 },
        hardware: {
          hinges: [
            {
              positionId: 'door_1_left_top_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: -25, y: 60, z: 10 },
            },
            {
              positionId: 'door_1_left_top_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: -25, y: 310, z: 10 },
            },
            {
              positionId: 'door_1_left_top_hinge_3',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: -25, y: 560, z: 10 },
            },
            {
              positionId: 'door_1_left_bottom_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: -25, y: 1350, z: 10 },
            },
            {
              positionId: 'door_1_left_bottom_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: -25, y: 1550, z: 10 },
            },
          ],
        },
      },
      {
        positionId: 'door_1_right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1900,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 410, y: 300, z: 0 },
      },
      {
        positionId: 'door_1_top_frame_profile',
        type: 'PROFILE',
        width: 410,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 60, y: 300, z: 0 },
      },
      {
        positionId: 'door_1_bottom_frame_profile',
        type: 'PROFILE',
        width: 410,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 60, y: 2140, z: 0 },
      },
      // door 2
      {
        positionId: 'door_2_left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1900,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 530, y: 300, z: 0 },
      },
      {
        positionId: 'door_2_right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1900,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 1280, y: 300, z: 0 },
        hardware: {
          hinges: [
            {
              positionId: 'door_2_right_top_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 60, z: 10 },
            },
            {
              positionId: 'door_2_right_top_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 310, z: 10 },
            },
            {
              positionId: 'door_2_right_top_hinge_3',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 560, z: 10 },
            },
            {
              positionId: 'door_2_right_bottom_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 1350, z: 10 },
            },
            {
              positionId: 'door_2_right_bottom_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 1550, z: 10 },
            },
          ],
        },
      },
      {
        positionId: 'door_2_top_frame_profile',
        type: 'PROFILE',
        width: 810,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 530, y: 300, z: 0 },
      },
      {
        positionId: 'door_2_bottom_frame_profile',
        type: 'PROFILE',
        width: 810,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 530, y: 2140, z: 0 },
      },

      // Glass Panels
      {
        positionId: 'door_top_glass_panel',
        type: 'GLASS',
        width: 1280,
        height: 180,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 60, y: 60, z: 0 },
      },
      {
        positionId: 'door_glass_panel_1',
        type: 'GLASS',
        width: 290, // FIXED: Adjusted width
        height: 1780,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 120, y: 360, z: 0 },
        hardware: {
          handles: [], // Left door typically has no handle
        },
      },
      {
        positionId: 'door_glass_panel_2',
        type: 'GLASS',
        width: 690, // FIXED: Adjusted width
        height: 1780,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 590, y: 360, z: 0 }, // FIXED: Adjusted X position
        hardware: {
          handles: [
            {
              positionId: 'door_horizontal_handle_right',
              type: 'HORIZONTAL_HANDLE',
              width: 120,
              height: 200,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: -60, y: 750, z: 10 }, // FIXED: Centered position
            },
          ],
        },
      },
    ],
    doorConfiguration: {
      type: 'double_door',
      totalDoorWidth: 1400,
      individualDoorWidth: [500, 900],
      totalHandles: 1,
      openingDirection: 'right_opening',
      hingePosition: 'right_side',
      leftDoorWidth: 500,
      rightDoorWidth: 900,
      centerSeparatorWidth: 40,
    },
  }
